const isDev = process.env.NODE_ENV === "development";

export const imageBaseUrl = isDev
  ? "https://usersapi.riteliberia.org" //"https://localhost:44313"
  : "https://usersapi.riteliberia.org";

export const userApiBaseUrl = isDev
  ? "https://usersapi.riteliberia.org/api" //"https://localhost:44313/api"
  : "https://usersapi.riteliberia.org/api";

export const workflowApiBaseUrl = isDev
  ? "https://workflowsapi.riteliberia.org/api" //"https://localhost:44315/api"
  : "https://workflowsapi.riteliberia.org/api";

export const patientApiBaseUrl = isDev
  ? "https://personsapi.riteliberia.org/api" //"https://localhost:44316/api"
  : "https://personsapi.riteliberia.org/api";
